export const GOI_PHONE = "1666-9784";
export const GOI_PHONE_HREF = `tel:${GOI_PHONE}`;
